import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  sectionHeaderWrapper: {
    gap: theme.spacing(3),
  },
  textContentWrapper: {
    gap: theme.spacing(1.25),
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
  },
  colorSelectorWidth: { width: '265px' },
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  content: {
    padding: theme.spacing(4, 5),
  },
  sectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    height: 'auto',
  },
  textHeading: {
    color: '#381E1C',
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.25px',
  },
}))
